import { render, staticRenderFns } from "./budgetItem.vue?vue&type=template&id=1174f0fa"
import script from "./budgetItem.vue?vue&type=script&lang=js"
export * from "./budgetItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1174f0fa')) {
      api.createRecord('1174f0fa', component.options)
    } else {
      api.reload('1174f0fa', component.options)
    }
    module.hot.accept("./budgetItem.vue?vue&type=template&id=1174f0fa", function () {
      api.rerender('1174f0fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/budget/budgetItem.vue"
export default component.exports